(function () {
  const BANNER_ID = 'shopify-pc__banner';
  let initialized = false;

  const initDialog = (dialog) => {
    if (initialized) return;
    initialized = true;

    dialog.setAttribute('aria-modal', 'true');

    const focusableSelectors = `
      a[href],
      button:not([disabled]),
      textarea,
      input,
      select,
      [tabindex]:not([tabindex="-1"])
    `;

    const getFocusable = () =>
      [...dialog.querySelectorAll(focusableSelectors)]
        .filter(el => el.offsetParent !== null);

    const focusables = getFocusable();
    if (focusables.length) {
      focusables[0].focus();
    }

    dialog.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;

      const items = getFocusable();
      if (!items.length) return;

      const first = items[0];
      const last = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  };

  // If already in DOM
  const existing = document.getElementById(BANNER_ID);
  if (existing) {
    initDialog(existing);
    return;
  }

  // Observe async injection
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;

        if (node.id === BANNER_ID) {
          observer.disconnect();
          initDialog(node);
          return;
        }

        const banner = node.querySelector?.(`#${BANNER_ID}`);
        if (banner) {
          observer.disconnect();
          initDialog(banner);
          return;
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();